<template>
  <main v-if="project" class="layout-project">
    <ProjectHeader :data="project" />
    <Modules :modules="project.modules" />
  </main>
</template>

<script setup lang="ts">
import gsap from 'gsap';
import { useSeo } from '~/utils/useSeo';
import ProjectHeader from '~/components/unsorted/ProjectHeader.vue';
import { useSiteHeaderBackground } from '~/utils/useSiteHeaderBackground';

const route = useRoute();
const slug = String(route.params.slug);

const i18n = useI18n();

const { data, error } = await useAsyncGql({
  operation: 'GetProjectByTranslatedSlug',
  variables: { slug, locale: i18n.localeProperties.value.siteLocale },
});

const project = data.value?.project;

if (!project || error.value) {
  showError({
    statusCode: 404,
  });
}

if (project) {
  useSeo(project._seoMetaTags ?? [], project);
}

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    de: '/referenzen/[slug]',
    fr: '/projets/[slug]',
  },
});

useSiteHeaderBackground('opaque');

definePageMeta({
  pageTransition: {
    async onEnter(el, done) {
      const homePage = document.querySelector('.horizontal-layout');

      if (!homePage) {
        return done;
      }

      const modules = el.querySelectorAll('.module');
      const siteFooter = document.querySelectorAll('.site-footer');

      gsap.set([modules, siteFooter], {
        visibility: 'hidden',
        opacity: 0,
      });

      await useWait(1000);

      gsap.set([modules, siteFooter], {
        opacity: 1,
        visibility: 'visible',
      });

      done();
    },
  },
});
</script>

<style scoped lang="scss">
.layout-project {
  display: flex;
  flex-direction: column;

  @media (--vs) {
    gap: 5rem;
  }

  @media (--vl) {
    gap: 7.5rem;
  }
}
</style>
